export default __webpack_public_path__ + "static/warrior_header-728d9ab95b0bbdd365f607c2514cbdba.png";